// 답변 팝업을 보여줌
export const SHOW_COMMENT_REPLY_POPUP = "SHOW_COMMENT_REPLY_POPUP";

// 스팸 차단 팝업을 보여줌
export const SHOW_COMMENT_BLOCK_POPUP = "SHOW_COMMENT_BLOCK_POPUP";

// 새로운 스킨 업로드 팝업을 보여줌
export const SHOW_SKIN_ADD_POPUP = "SHOW_SKIN_ADD_POPUP";

// 스킨 정보를 표시하는 밥업을 보여줌
export const SHOW_SKIN_DETAIL_POPUP = "SHOW_SKIN_DETAIL_POPUP";

// 사이드바 모듈 수정 팝업 보여줌
export const SHOW_EDIT_SIDEBAR_MODULE_POPUP = "SHOW_EDIT_SIDEBAR_MODULE_POPUP";

// 에러 토스트 팝업 보여줌
export const SHOW_ERROR_TOAST_POPUP = "SHOW_ERROR_TOAST_POPUP";

// 로딩 팝업 보여줌
export const SHOW_LOADING_POPUP = "SHOW_LOADING_POPUP";

// 로딩 팝업 숨김
export const HIDE_LOADING_POPUP = "HIDE_LOADING_POPUP";


// 블로그 데이터 삭제 결과 팝업
export const SHOW_CLEAR_DATA_RESULT_POPUP = "SHOW_CLEAR_DATA_RESULT_POPUP";

// 블로그 폐쇄 결과 팝업
export const SHOW_CLOSE_BLOG_RESULT_POPUP = "SHOW_CLOSE_BLOG_RESULT_POPUP";

// 팝업을 닫음
export const CLOSE_POPUP = "CLOSE_POPUP";

// 카테고리 이동 팝업 보여줌
export const SHOW_MOVING_CATEGORY_POPUP = "SHOW_MOVING_CATEGORY_POPUP";
